import eventTypeOptionsUrl from './eventTypeOptions.html';
export default {
  templateUrl: eventTypeOptionsUrl,
  controllerAs: 'ctrl',
  controller: class {
    filterExplicitlySelected = (item) =>
      this.filter.eventTypes &&
      this.filter.eventTypes.length &&
      this.filter.eventTypes.includes(item.id);

    filterNotExplicitlySelected = (item) =>
      !this.filter.eventTypes ||
      !this.filter.eventTypes.length ||
      !this.filter.eventTypes.includes(item.id);
  },
  bindings: {
    toggleFilter: '&',
    options: '=',
    filter: '=',
  },
  require: {
    dropdownFilterCtrl: '^?dropdownFilter',
  },
};
